export default __webpack_public_path__ + "img/9ea06b3.svg";